import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Textarea,
} from "@nextui-org/react";
import UpdateLayout from "../layouts/UpdateLayout";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";
import axios from "axios";
const DisputeMessage = () => {
  const { id } = useParams();
  const role = localStorage.getItem("role");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [disputeDetails, setDisputeDtails] = useState({});
  const [disputeRole, setDisputeRole] = useState("");
  const [message, setMessage] = useState("");
  const [multipleOffer, setMultipleOffer] = useState([]);


  const [busy, setBusy] = useState(false);
  const dispatch = useDispatch();

  // fresh auth headers helper
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    const fresh = localStorage.getItem("accessToken");
    return {
      headers: {
        Authorization: `Bearer ${fresh}`,
        "Content-Type": "application/json",
      },
    };
  };
  const handleOpen = () => {
    onOpen();
  };
  const handleResponse = async () => {
    if (!message?.trim()) {
      toast.error("Response cannot be empty");
      return;
    }
    setBusy(true);
    let data = {
      response: message,
    };
    try {
      const headers = await ensureAuth();
      await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/disputes/${id}/response`,
        data,
        headers
      );
      getDisputeById(id);
      onClose();
      toast.success("Response added successfully.");
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    } finally {
      setBusy(false);
    }
  };

  const getDisputeById = async (id) => {
    try {
      const headers = await ensureAuth();
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/disputes/${id}`,
        headers
      );
      let dispute_role = res.data?.details?.disputes?.description || "";
      if (dispute_role.includes("SUPPLIER")) {
        setDisputeRole("SUPPLIER");
      } else if (dispute_role.includes("CUSTOMER")) {
        setDisputeRole("CUSTOMER");
      }
      setDisputeDtails(res.data?.details);
      setMultipleOffer(res.data?.details?.disputes?.Order?.Quote?.QuoteOptions)
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    }
  };

  useEffect(() => {
    getDisputeById(id);
  }, []);


  return (
    <div className="select-none">
      <UpdateLayout
        heading={"Dispute Order Details"}
        title=""
        images={disputeDetails?.images}
        requestId={disputeDetails?.disputes?.Order?.request_id}
        
      >
        <div className="flex justify-between items-center mt-8 mb-5  ">
          <p className="font-semibold">Order Details</p>
          <div>

            <Chip className="capitalize border-[#EF4444] bg-[#FDD0DF] text-[#EF4444]" color="danger" variant="dot">
              Disputed
            </Chip>
            {disputeDetails?.disputes?.Order?.Quote?.Payments?.at(-1)?.paymentMethod && <Chip
              color="secondary"
              variant="dot"
              className="float-right text-purple-400 border-[2px] border-purple-400 ml-2"
            >
              <p>{disputeDetails?.disputes?.Order?.Quote?.Payments?.at(-1)?.paymentMethod}</p>
            </Chip>}
          </div>
        </div>
        <div className=" space-y-5">
          <div className=" grid grid-cols-3   ">
            <div>
              <p className=" font-semibold">Order Id</p>
              <p >{disputeDetails?.disputes?.id}</p>
            
            </div>
            <div>
              <p className=" font-semibold">Quantity</p>
              <p>{disputeDetails?.disputes?.Order?.Request?.quantity}</p>
            </div>
            <div>
              <p className=" font-semibold">Recieved Order Date</p>
              <p>
                {disputeDetails?.disputes?.received_date?.split("T")[0]}
              </p>
            </div>
          </div>
          {/* {  console.log(disputeDetails?.disputes?.Order?.Request?.VehicleMake?.name)} */}
          <div className=" grid grid-cols-3  ">
            <div className="capitalize">
              <p className=" font-semibold">Make</p>
              <p>{disputeDetails?.disputes?.Order?.Request?.VehicleMake?.name.toLowerCase()}</p>
            </div>
            <div>
              <p className=" font-semibold">Model</p>
              <p>
                {disputeDetails?.disputes?.Order?.Request?.VehicleModel?.name}
              </p>
            </div>
            <div>
              <p className=" font-semibold">Part Type</p>
              <p className="capitalize">{disputeDetails?.disputes?.Order?.Request?.Part?.name.toLowerCase() || "Not Provided"}</p>
            </div>
          </div>
          <div className=" grid grid-cols-3  ">
            <div>
              <p className=" font-semibold">Part Price</p>
              <p>{disputeDetails?.disputes?.Order?.Quote?.part_price}</p>
            </div>
            <div>
              <p className=" font-semibold">Frieght Price</p>
              <p>{disputeDetails?.disputes?.Order?.Quote?.freight_price}</p>
            </div>
            <div>
              <p className=" font-semibold">Total Price</p>
              <p>{disputeDetails?.disputes?.Order?.Quote?.total_price}</p>
            </div>
          </div>

          <div className="  mt-4 space-y-2 ">
            <div >
              <span className="text-sm sm:text-base font-semibold ">Title: </span>
              <span className={`${disputeDetails?.disputes?.titlee?.name === "Credit Request" ? "bg-yellow-200   text-[0.8rem]  px-2 py-1" : " font-semibold"}`}>
                {disputeDetails?.disputes?.titlee?.name}
              </span>
            </div>
            <div>
              <span className="text-sm sm:text-base font-semibold">
                Description:{" "}
              </span>
              <span className=" font-semibold">
                {disputeDetails?.disputes?.description.split(":")[1]}
              </span>
            </div>

          </div>


        </div>



        {disputeRole &&
          role !== disputeRole &&
          !disputeDetails?.disputes?.response ? (
          <div className="flex justify-center mt-7">
            <Button
              className="bg-lightBlue font-semibold text-white px-7 mobile-only:w-full"
              onPress={() => handleOpen()}
            >
              Add Your Thought
            </Button>
          </div>
        ) : (
          ""
        )}

      </UpdateLayout>
      {disputeDetails?.disputes?.response ? (
        <div className="mx-0 sm:mx-10 my-5 ">
          <p className="font-semibold pb-2 border-b-1 border-gray-300">
            Response:
          </p>
          <div className="mt-3">
            <p className="text-xs sm:text-sm">
              {disputeDetails?.disputes?.response.split(":")[1]}
            </p>
          </div>
        </div>
      ) : (
        ""
      )}
      <Modal size={"md"} isOpen={isOpen} onClose={onClose} placement="center">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                Submit Your Response On this
              </ModalHeader>
              <ModalBody>
                <Textarea
                  key={"bordered"}
                  variant={"bordered"}
                  label={"Response"}
                  labelPlacement="outside"
                  placeholder={"Write Here"}
                  className="col-span-12 md:col-span-6 mb-6 md:mb-0"
                  onChange={(e) => setMessage(e.target.value)}
                />
              </ModalBody>
              <ModalFooter>
                <Button className="bg-purpleBtn text-white" onPress={onClose}>
                  Close
                </Button>
                {" "}
                <Button
                  className="bg-lightBlue text-white"
                  onPress={handleResponse}
                  isDisabled={busy}
                  isLoading={busy}
                >
                   Submit {" "}
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};

export default DisputeMessage;
